import { renderToString } from "react-dom/server";
import { TABLE_BODY_INFO_PREVIEW } from "util/tableVariable.js";
import { TABLE_DATA } from "util";

export const table_render = (type, sheet) => {
    const BORDER = "1pt solid #000";

    const tbl = sheet[type];
    const header = sheet["header"];
    const so = sheet["sub"];
    const table = document.createElement("table");
    table.classList.add("bpl-table");
    table.style.borderSpacing = "0";
    table.style.borderCollapse = "separate";
    table.style.fontSize = "8pt";
    table.style.border = "none";
    const master = sheet['master'];
    const tblNm = master.projectNm+master.mbrNo;
    /*
        Header
    */
    table.innerHTML = renderToString(TABLE_DATA?.header?.[type](header, false, { previewMode: true }, true, true));

    /*
        Body
    */

    const tbody = document.createElement("tbody");

    const SEPERATOR = type === "composition" ? "/" : " ";

    let remarks = [];
    let remarkNum = null;

    if (type === "composition") {
        for (let d2 of tbl) {
            let tr2 = document.createElement("tr");
            let remarkStr = "";
            let remarkVal = d2.remark;
            if (remarkVal && remarkVal !== "FALSE" && remarkVal !== "") {
                remarkNum = remarks.findIndex(row => remarkVal === row.value)
                if (remarkNum < 0) {
                    remarks.push({
                        value: remarkVal,
                    });
                    remarkNum = remarks.length;
                } else {
                    remarkNum = remarkNum + 1;
                }
                remarkStr = "[" + remarkNum + "]";
            }
            let j = 0;
            for (let body_info of TABLE_BODY_INFO_PREVIEW[type]) {
                let td2 = document.createElement("td");

                const chk = body_info.split("+");
                if ((chk.length > 1 && !chk[1]?.includes("Cd")) && (d2[chk[0]] + d2[chk[1]]).length > 0) {
                    td2.innerText = (d2[chk[0]] || "") + SEPERATOR + (d2[chk[1]] || "");
                } else {
                    td2.innerText = d2[chk[0]] || "";
                }
                if (td2.innerText.replaceAll(/[ /]/g, "").length < 1) {
                    td2.style.backgroundColor = "#DDD";
                }
                if (j < 1) {
                    td2.innerText = `${td2.innerText} ${remarkStr}`;
                    remarkStr = "";
                    j++;
                }
                tr2.appendChild(td2);
            }
            tbody.appendChild(tr2);
        }
    } else {
        for (let d1 in tbl) {
            let remarkVal = so[d1][type + "Remark"];
            if (tbl[d1]?.filter((f) => f.hide !== "TRUE").length < 1 && remarkVal === "FALSE") {
                continue;
            }

            let tr1 = document.createElement("tr");

            let td1 = document.createElement("td");
            td1.colSpan = TABLE_BODY_INFO_PREVIEW[type].length;

            td1.style.textAlign = "center";
            td1.style.fontWeight = "bold";

            let remarkStr = "";
            if (remarkVal && remarkVal !== "FALSE" && remarkVal !== "") {
                remarkNum = remarks.findIndex(row => remarkVal === row.value)
                if (remarkNum < 0) {
                    remarks.push({
                        value: remarkVal,
                    });
                    remarkNum = remarks.length;
                } else {
                    remarkNum = remarkNum + 1;
                }
                remarkStr = "[" + remarkNum + "]";
            }

            td1.innerText = `${so[d1]["description"]} ${remarkStr}`;

            tr1.appendChild(td1);

            tbody.appendChild(tr1);

            for (let d2 of tbl[d1]) {
                if (d2.hide !== "TRUE") {
                    let tr2 = document.createElement("tr");
                    let remarkStr = "";
                    if (d2.remark && d2.remark !== "FALSE" && d2.remark !== "") {
                        let remarkNum = remarks.findIndex(row => d2.remark === row.value)
                        if (remarkNum < 0) {
                            remarks.push({
                                value: d2.remark,
                            });
                            remarkNum = remarks.length;
                        } else {
                            remarkNum = remarkNum + 1;
                        }
                        remarkStr = "[" + remarkNum + "]";
                    }
                    let j = 0;
                    for (let body_info of TABLE_BODY_INFO_PREVIEW[type]) {
                        let td2 = document.createElement("td");

                        const chk = body_info.split("+");

                        const cellnm = chk?.[1] || chk?.[0];
                        td2.dataset.cellnm = cellnm;

                        if (chk.length > 1 && !chk[1]?.includes("Cd")) {
                            td2.innerText = (d2[chk[0]] || "") + SEPERATOR + (d2[chk[1]] || "");
                        } else {
                            td2.innerText = d2[chk[0]] || "";
                        }
                        if (td2.innerText.replaceAll(" ", "").length < 1) {
                            td2.style.backgroundColor = "#DDD";
                        }

                        if (j < 1) {
                            td2.innerText = `${td2.innerText} ${remarkStr}`;
                            remarkStr = "";
                            j++;
                        }
                        if(td2.dataset.cellnm === "unit" || td2.dataset.cellnm === "rcvCriticalNm" || td2.dataset.cellnm === "sopNo" ||
                            td2.dataset.cellnm === "testMethod" || td2.dataset.cellnm === "sndCritical"
                        ){
                            td2.style.textAlign = "center";
                        }
                        tr2.appendChild(td2);
                    }

                    tbody.appendChild(tr2);
                }
            }
        }
    }

    table.appendChild(tbody);

    table.style.width = "100%";

    table.querySelectorAll("tr:last-child > td").forEach((element) => {
        element.style.borderBottom = BORDER;
    });

    const figure = document.createElement("figure");
    figure.classList.add("data-table-figure", "table");
    figure.style.width = "100%";
    figure.appendChild(table);

    const pageDiv = document.createElement("div");

    const mainDesc = sheet?.master?.description;

    switch (type.toString().toUpperCase()) {
        case "IN":
            pageDiv.innerHTML = `<h4 class='exclude_heading'>Operational Parameter${mainDesc && " (" + mainDesc + ")"}</h4>`;
            break;
        case "OUT":
            pageDiv.innerHTML = `<h4 class='exclude_heading'>Performance Parameter${mainDesc && " (" + mainDesc + ")"}</h4>`;
            break;
        case "QC":
            pageDiv.innerHTML = `<h4 class='exclude_heading'>Performance Parameter - QC${mainDesc && " (" + mainDesc + ")"}</h4>`;
            break;
        case "COMPOSITION":
            pageDiv.innerHTML = `<h4 class='exclude_heading'>Composition${mainDesc && " (" + mainDesc + ")"}</h4>`;
            break;
        default:
            break;
    }

    if (!tbody.innerHTML) {
        const p = document.createElement("p");
        p.style.fontSize = "1.1rem";
        p.innerText = "Not applicable";

        pageDiv.appendChild(p);
    } else {
        const figcaption = document.createElement("figcaption");
        figcaption.dataset.tblnm = tblNm.toUpperCase();
        figcaption.dataset.tbltp = type.toUpperCase();
        figcaption.innerText = pageDiv.querySelector("h4").innerText;
        figure.appendChild(figcaption);
        pageDiv.appendChild(figure);

        if (remarks.length > 0) {
            const ul = document.createElement("ul");
            for (let i in remarks) {
                let li = document.createElement("li");
                li.style.fontSize = "8pt";
                li.innerText = "[" + (parseInt(i) + 1) + "] " + remarks[i].value;
                ul.appendChild(li);
            }
            ul.style.listStyle = "none";
            ul.classList.add("bpl-remark-ul")
            pageDiv.appendChild(ul);
        }
    }

    return pageDiv.innerHTML;
};